export default __webpack_public_path__ + "static/media/img-2.73b5ca54.jpg";